// See https://developers.google.com/maps/documentation/javascript/styling for examples of styling.
// See https://developers.google.com/maps/documentation/javascript/style-reference for element types reference

export default {
  gestureHandling: 'cooperative'
};
